import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-causales-no-entrega',
  templateUrl: './administracion-causales-no-entrega.component.html',
  styleUrls: ['./administracion-causales-no-entrega.component.css']
})
export class AdministracionCausalesNoEntregaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
